import React, { useState } from 'react';

const EyeIcon = ({ visible }) =>
  visible ? (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

const slugify = (str = '') =>
  str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

// Les attributs restants (`autoComplete`, `inputMode`, `maxLength`, `passwordrules`…)
// sont transmis tels quels à l'<input> : ce sont eux qui permettent aux gestionnaires
// de mots de passe (trousseau iCloud, Google, 1Password…) de reconnaître les champs,
// de proposer un mot de passe fort et de l'enregistrer.
const FormInput = ({
  type = 'text', placeholder, value, onChange, onBlur, unit, readOnly, onClick,
  label, id, name, error, ...inputProps
}) => {
  const [showPwd, setShowPwd] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPwd ? 'text' : 'password') : type;
  const inputId = id || slugify(name || label || placeholder);
  const inputName = name || inputId;
  const a11y = error ? { 'aria-invalid': true } : {};

  if (unit) {
    return (
      <div className="form-group">
        {label && <label className="form-label" htmlFor={inputId}>{label}</label>}
        <div className="input-with-unit">
          <input
            id={inputId}
            name={inputName}
            type={inputType}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className="form-input"
            readOnly={readOnly}
            {...a11y}
            {...inputProps}
          />
          <span className="input-unit">{unit}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="form-group">
      {label && <label className="form-label" htmlFor={inputId}>{label}</label>}
      <div style={isPassword ? { position: 'relative' } : undefined}>
        <input
          id={inputId}
          name={inputName}
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onClick={onClick}
          className="form-input"
          readOnly={readOnly}
          style={isPassword ? { paddingRight: '44px' } : undefined}
          {...a11y}
          {...inputProps}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPwd((v) => !v)}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              color: 'var(--color-text-secondary)',
              display: 'flex',
              alignItems: 'center',
            }}
            tabIndex={-1}
            aria-label={showPwd ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          >
            <EyeIcon visible={showPwd} />
          </button>
        )}
      </div>
    </div>
  );
};

export default FormInput;
